require('./_polyfills');

require('./_fa');

var useragent = require('ua-parser-js');

import BodyClassToggler from './components/BodyClassToggler';
import Tabs from './components/Tabs';
import SmoothScroller from './components/SmoothScroller';
import WpTimelineBlock from './components/WpTimelineBlock';
import WpCounterBlock from './components/WpCounterBlock';
import Vendor from './components/Vendor';
import SiteControls from './components/SiteControls';
import ResourceFilter from './components/ResourceFilter'; // save ua for any component

var ua = useragent();
new SiteControls(); // BLOCKS

new WpTimelineBlock();
new WpCounterBlock(); // new Tabs()

var tablists = Array.from(document.querySelectorAll('[role="tablist"]'));
tablists.forEach(function (tablist) {
  return new Tabs(tablist);
});
new ResourceFilter(); // TODO TEST

var smooth = new SmoothScroller();
smooth.scrollOnLoad();
smooth.bindHashLinks(); // VENDOR

Vendor.parseUaToDom(ua);
Vendor.wpImageBlockModals();
Vendor.wpGalleryBlockModals();
document.addEventListener('focusin', function () {
  return console.log('focus', document.activeElement);
});